'use client';
import * as React from 'react';

function useRecaptcha(props) {
    var _a = props || {
        siteId: "",
        loadDelay: 3500,
    }, siteId = _a.siteId, _b = _a.loadDelay, loadDelay = _b === void 0 ? 3500 : _b;
    React.useEffect(function () {
        setTimeout(function () {
            var scriptTag = document.createElement("script");
            scriptTag.src = "https://www.google.com/recaptcha/api.js?render=".concat(siteId);
            document.body.appendChild(scriptTag);
        }, loadDelay);
    }, [siteId, loadDelay]);
}

export { useRecaptcha };
